/** W17 Final GOT Grade Update (legacy QCM, manual p221). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { GotFinalGradeListPage } from "@/features/got/components/final-grade-page";

export const Route = createFileRoute("/_app/quality/got/final-grade/")({
  beforeLoad: () => {
    if (!useAuth.getState().can("got.final_grade")) throw redirect({ to: "/" });
  },
  component: GotFinalGradeListPage,
});
